//
// NavigationActionType.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var NavigationActionType = {
    NONE:0,
    URL:1,
    CONTEXT:2,
    REPORT:4,
    SECTION:8
};
export default NavigationActionType;
